import { mutatorAction } from "satcheljs";
import { userOutlookClientsStore } from "../store/store";
import { getUserOutlookClientByType } from "../selectors/getUserOutlookClientByType";
import { updateUserOutlookClient } from "../services/updateUserOutlookClient";
import { getClientVersion } from "owa-config";
import { owaDate } from "owa-datetime";
import { logCoreUsage } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export const OutlookClientsToUpdate: string[] = ["OWA"];

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setPhoneAppCardDismissState: (isCardDismissed: boolean) => void = mutatorAction("setPhoneAppCardDismissState", (isCardDismissed: boolean): void => {
    const store = userOutlookClientsStore();
    store.isCardDismissed = isCardDismissed;
    
    OutlookClientsToUpdate.forEach(clientType => {
        const userClient = getUserOutlookClientByType(clientType);
        if (userClient) {
            /* eslint-disable-next-line owa-custom-rules/forbid-specific-functions-patterns-inside-loops -- (https://aka.ms/OWALintWiki)
             * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
             * Baseline, this function can't be used inside a loop, please move it outside
             *	> Function 'logCoreUsage' matches forbidden pattern (/logCoreUsage/) and should not be used inside loops */
            logCoreUsage("UpdateUserOutlookClient", getModuleContextMailboxInfo(), {
                clientId: userClient.clientId,
                mobilePromoDismissDate: owaDate().toString(),
                clientType: userClient.clientType,
            });
            updateUserOutlookClient({
                clientId: userClient.clientId,
                clientType: userClient.clientType,
                clientVersion: getClientVersion(),
                mobilePromoDismissDate: owaDate(),
            });
        }
    });
});
